import { PATTERN_TYPES, PATTERNS_FIELDS } from '@/constants';

export default {
  patterns: 'Patterns',
  myPatterns: 'My patterns',
  corporatePatterns: 'Shared patterns',
  addRule: 'Add rule',
  addGroup: 'Add group',
  removeRule: 'Remove rule',
  advancedEditor: 'Advanced editor',
  simpleEditor: 'Simple editor',
  fixJsonWithAi: 'Fix JSON with AI',
  noData: 'No pattern set. Click \'@:pattern.addGroup\' button to start adding fields to the pattern',
  noDataDisabled: 'No pattern set.',
  alarmsCount: 'Found: <strong>{alarmsCount} alarms</strong>',
  entitiesCount: 'Found: <strong>{entitiesCount} entities</strong>',
  alarmsEntitiesCount: 'Found: <strong>{alarmsCount} alarms, {entitiesCount} entities</strong>',
  searchTime: 'Search time: <strong>{duration}</strong>',
  patternAlarms: 'Pattern alarms',
  patternEntities: 'Pattern entities',
  found: 'found: {message} / search time <strong>{searchTime}</strong>',
  alarmFound: '<strong>{count} alarm</strong> | <strong>{count} alarms</strong>',
  entityFound: '<strong>{count} entity</strong> | <strong>{count} entities</strong>',
  types: {
    [PATTERN_TYPES.alarm]: 'Alarm pattern',
    [PATTERN_TYPES.entity]: 'Entity pattern',
    [PATTERN_TYPES.pbehavior]: 'Pbehavior pattern',
    [PATTERN_TYPES.serviceWeather]: 'Service weather pattern',
  },
  patternsFields: {
    [PATTERNS_FIELDS.alarm]: 'Alarm',
    [PATTERNS_FIELDS.entity]: 'Entity',
    [PATTERNS_FIELDS.pbehavior]: 'Pbehavior',
    [PATTERNS_FIELDS.event]: 'Event',
    [PATTERNS_FIELDS.totalEntity]: 'Total entity',
    [PATTERNS_FIELDS.serviceWeather]: 'Weather service',
  },
  patternsMessage: '{patterns} pattern | {patterns} patterns',
  notDefinedType: 'Selected type differs from the type set in Entity infos',
  tryOptimization: 'Try optimization',
  tryOptimizationHint: 'Try optimization of Regexp to speed up the query<br><span class="font-weight-regular">Regexp queries usually work slower than normal queries.</span>',
  optimizationInProgress: 'Optimization in progress...',
  optimizationFailed: 'Optimization failed : {reason}',
  cancelOptimization: 'Cancel optimization',
  patternsCreationInProgress: 'Patterns creation in progress...',
  cancelPatternsCreation: 'Cancel Patterns creation',
  patternsUpdateInProgress: 'Patterns update in progress...',
  cancelPatternsUpdate: 'Cancel Patterns update',
  optimizationCancelled: 'Optimization was cancelled',
  suggestions: 'Suggestions',
  rejectAllSuggestions: 'REJECT ALL SUGGESTIONS',
  foundEntities: 'found: <strong>{count} entities</strong>',
  sameEntities: 'same entities',
  seeRecordsComparison: 'See records comparison',
  conditionsOptimized: 'The following <strong>regular expressions</strong> were optimized:',
  applyThisSuggestion: 'APPLY THIS SUGGESTION',
  optimizationSuggestionsWasntFound: 'No <strong>regexp</strong> optimization suggestions found',
  errors: {
    ruleRequired: 'Please add at least one rule',
    groupRequired: 'Please add at least one group',
    invalidPatterns: 'Patterns are invalid or there is a disabled pattern field',
    countOverLimit: 'The patterns you\'ve defined targets about {count} items. It can affect performance, are you sure ?',
    existExcluded: 'The rules include excluded rule.',
    required: 'At least one pattern has to be defined. Please define filter patterns for rule',
  },
};
